<template>
    <custom-dialog :dialog-title="dialogTitle" :handle-dialog-close="onDialogClose"
        countainerClass="mobile-only-dialog">
      <div class="modal-wrapper">
        <div class="app-info">
          <div class="info-text">
            <p v-html="$t('discount.mobileRestrict.info')"></p>
            <h2 class="info-heading">{{ $t('discount.mobileRestrict.properties.heading') }}</h2>
            <ul class="app-info-list">
              <li>{{ $t('discount.mobileRestrict.properties.digitalCard') }}</li>
              <li>{{ $t('discount.mobileRestrict.properties.offers') }}</li>
              <li>{{ $t('discount.mobileRestrict.properties.vouchers') }}</li>
              <li>{{ $t('discount.mobileRestrict.properties.favourites') }}</li>
              <li>{{ $t('discount.mobileRestrict.properties.world') }}</li>
            </ul>
          </div>
          <div class="image-wrapper">
            <mobile-app-image />
          </div>
        </div>
        <div class="store-badges-wrapper">
          <a class="google-badge" href="https://play.google.com/store/apps/details?id=nl.jool.isic">
            <img alt="Get it on Google Play" src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"/>
          </a>
          <a class="apple-badge" href="https://apps.apple.com/us/app/isic/id886109982">
            <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1402790400"
                alt="Download on the App Store">
          </a>
        </div>
      </div>
    </custom-dialog>
</template>
<style>
  .dialog-container.mobile-only-dialog {
    max-width: 900px;
  }
  @media screen and (max-width: 920px) {
    .dialog-container.mobile-only-dialog {
      max-width: 750px;
    }
  }
  @media screen and (max-width: 820px) {
    .dialog-container.mobile-only-dialog {
      max-width: 650px;
    }
  }
  .app-info a {
    color: var(--primary-color);
  }
  .app-info a:hover {
    color: var(--secondary-color);
  }
</style>
<style scoped>
  .app-info {
    display: flex;
    justify-content: space-between;
    color: var(--secondary-color);
  }

  .info-text {
    text-align: justify;
    max-width: 600px;
  }

  .image-wrapper > img {
    width: 250px;
    margin-left: 16px;
  }

  .store-badges-wrapper {
    display: flex;
    align-items: center;
    margin-top: -50px;
  }

  @media screen and (max-width: 820px) {
    .app-info  {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .info-text {
      max-width: none;
    }
    .image-wrapper > img {
      width: 200px;
      margin-left: 0;
    }
    .modal-wrapper {
      justify-content: center;
    }
    .store-badges-wrapper {
      justify-content: center;
      margin-top: 0;
    }
  }

  .app-info > p {
    margin-top: 0;
  }
  .google-badge {
    width: 170px;
    height: 75px;
  }
  .google-badge > img {
    width: 170px;
    height: 75px;
  }
  .apple-badge {
    width: 150px;
    height: 70px;
  }
  .apple-badge > img {
    width: 150px;
    height: 70px;
  }
  .app-info-list li {
    list-style-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 -5 24 26" fill="%2340b8b8"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>');
    line-height: 2;
  }
  .app-info-list li::marker {
    line-height: 0.1;
  }

</style>

<script>
import { mapActions } from 'vuex';
import CustomDialog from '@/components/CustomDialog.vue';
import MobileAppImage from './MobileAppImage.vue';
import i18nProvider from '../../lang/i18nProvider';

export default {
  name: 'mobile-restrict-dialog',
  computed: {
    i18n() {
      return i18nProvider;
    },
    dialogTitle() {
      return this.i18n.t('discount.mobileRestrict.title');
    },
  },
  methods: {
    ...mapActions({
      closeMobileOnlyDialog: 'closeMobileOnlyDialog',
    }),
    onDialogClose() {
      this.closeMobileOnlyDialog();
    },
  },
  components: {
    CustomDialog,
    MobileAppImage,
  },
};
</script>
